export default {
    YES: 'Yes',
    NO: 'No',
    OK: 'OK',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    CONFIRM: 'Confirm',
    CONFIRM_DELETE: 'Are you sure you want to delete this item?',
    DROP_ZONE_1: 'Click to upload',
    DROP_ZONE_2: 'or drag and drop',
    DROP: 'Drop file',
    DROP_ZONE_FILE_TYPES: 'SVG, PNG, JPG, JPEG, WEBP',
    ACTIONS: 'Actions',
    UNLIMITED: 'UNLIMITED',
    BACK: 'Back',
    MISSING_PLACE: 'Missing place',
};
